import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const EditInfoTrigger = ({ onOpen }) => {
  return (
    <Tooltip title="Edit info">
      <IconButton onClick={onOpen} size="small">
        <EditIcon fontSize="inherit" />
      </IconButton>
    </Tooltip>
  );
};

export default EditInfoTrigger;
